<div class="google-ad-container">
  <!-- Main Ad Image -->
  <div class="ad-image">
    <img *ngIf="hasImage" [src]="backgroundImage" alt="Ad Background" class="ad-background-img">
    <div *ngIf="!hasImage" class="ad-placeholder">
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8984 8.99805H16.9097M3.39844 17.998L9.02344 12.373C10.0674 11.3684 11.3544 11.3684 12.3984 12.373L18.0234 17.998M15.7734 15.748L16.8984 14.623C17.9424 13.6184 19.2294 13.6184 20.2734 14.623L23.6484 17.998M3.39844 6.74805C3.39844 5.85294 3.75402 4.9945 4.38695 4.36156C5.01989 3.72863 5.87833 3.37305 6.77344 3.37305H20.2734C21.1685 3.37305 22.027 3.72863 22.6599 4.36156C23.2929 4.9945 23.6484 5.85294 23.6484 6.74805V20.248C23.6484 21.1432 23.2929 22.0016 22.6599 22.6345C22.027 23.2675 21.1685 23.623 20.2734 23.623H6.77344C5.87833 23.623 5.01989 23.2675 4.38695 22.6345C3.75402 22.0016 3.39844 21.1432 3.39844 20.248V6.74805Z" stroke="#BDC0C6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <!-- Ad Content -->
  <div class="ad-content">
    <div class="ad-title">{{ adTitle }}</div>
    <div class="company-name">{{ companyName }}</div>
  </div>
</div>